export default __webpack_public_path__ + "static/media/cancelIconBlack.f73d633f.svg";